/* eslint-disable valid-jsdoc */
import React from 'react';
import { flattenItems } from '../utils/flattenItems';
/**
 * Pick ids from items and flatten children.
 * Returns flatten ids list tree structure representation.
 * Not included items if they in `expandedById` map
 */
export function useFlattenListItems({ items, expandedById, getId }) {
    const order = React.useMemo(() => {
        return flattenItems(items, expandedById, getId);
    }, [items, expandedById, getId]);
    return order;
}
